import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ApiService from '../../services/apiService';
import Authorization from '../purchaseOrder/authorization';
import MessageGrid from '../purchaseRequisition/messageGrid';
import { useSelector } from 'react-redux';
import { buildPendingRequisitionsPOPayload, pendingLinesToSaveItems } from '../purchaseOrder/poItemGridUtils';
import { getCompany, getName, getUserId, getUserName } from '../../../Redux/selecters';
import '../../Assets/styles/addmenu.css';
import { RiRefreshLine } from 'react-icons/ri';
import { FaAngleLeft } from 'react-icons/fa6';
import { FaSave } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import Modal from 'react-bootstrap/Modal';
import Attachment from '../Attachment/attachment';
import PendingRequisitionsGrid from './pendingRequisitionsGrid';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null,
  fileName: '',
  remarks: '',
});

const DEFAULT_LPO_TYPE = { value: 'Commercial', label: 'Commercial' };
const DEFAULT_REQ_TYPE = { value: 'Inventory', label: 'Inventory' };

const getTypeOfDocFromLpo = (lPOType) => {
  const type = lPOType?.label || lPOType?.value;
  return type && type !== 'None' ? type : 'Commercial';
};

const getApiErrorMessage = (responseOrError, fallback = 'Failed to save Direct Purchase Kanoo') => {
  const data = responseOrError?.response?.data ?? responseOrError?.data ?? responseOrError;
  if (!data) return fallback;
  if (typeof data === 'string') return data;
  if (data.message) return data.message;
  if (Array.isArray(data.errors) && data.errors.length) {
    return data.errors.filter(Boolean).join(', ');
  }
  if (data.apiException) return String(data.apiException);
  if (data.statusCode) return `${fallback} (status ${data.statusCode})`;
  return fallback;
};

const isPendingRequisitionsPOSuccess = (response) => {
  const data = response?.data;
  if (!data || data.isSuccessful === false) return false;
  if (data.result?.isSuccessful === false) return false;
  const code = data.statusCode;
  return code === 200 || code === 201;
};

const getCreatedPOrderNo = (response, fallbackDocNo) => response?.data?.result?.pOrderNo || fallbackDocNo;

const CreateDirectPurchaseKanoo = () => {
  const REPORT_URL = process.env.REACT_APP_REPORTS_URL;

  const [activeTab, setActiveTab] = useState(0);
  const [SupplierTab, setSupplierTab] = useState(false);
  const [POTab, setPOTab] = useState(true);
  const [CostTab, setCostTab] = useState(false);
  const [gridVisibility, setGridVisibility] = useState([true, false, false]);
  const [messageData, setMessageData] = useState([]);
  const [authorizationData, setAuthorizationData] = useState([]);
  const [selectedPendingLines, setSelectedPendingLines] = useState([]);

  const [suppliers, setSupplier] = useState([]);
  const [payments, setPayments] = useState([]);
  const [SelectedCurrency, setSelectedCurency] = useState([]);
  const [usersDetails, setUser] = useState([]);
  const [Supplier, setSupplierData] = useState([]);
  const [SupplierID, setSupplierID] = useState([]);
  const [isVatExcluded, setIsVatExcluded] = useState(true);
  const [isDiscountPercentage, setIsDiscountPercentage] = useState(true);
  const [SupplierContact, setSupplierContact] = useState();
  const [Payment, setPayment] = useState([]);
  const [docNumber, setDocNumber] = useState([]);
  const [cost1, setCost1] = useState([]);
  const [cost2, setCost2] = useState([]);
  const [cost3, setCost3] = useState([]);
  const [cost4, setCost4] = useState([]);
  const [contactNumber, setContactNumber] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const userId = useSelector(getUserId);
  const userName = useSelector(getUserName);
  const Company = useSelector(getCompany);
  const itemData = location.state;
  const currentDatetimeUTC = new Date().toISOString().slice(0, 16);
  const [docModal, setDocModal] = useState(false);
  const onOpenModal = () => setDocModal(true);
  const onCloseModal = () => setDocModal(false);
  const apiService = new ApiService();
  // Attachment
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const handleOpen = () => setAttachmentModal(true);
  const closeModal = () => setAttachmentModal(false);
  const isReadOnly = itemData?.eye === true;
  const [isXtreamCompany, setXtreamCompany] = useState(false);
  const [overallDiscount, setOverallDiscount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [vatAmount, setVatAmount] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);

  const getCurrentLocalDatetime = () => {
    const localDate = new Date();
    const offset = localDate.getTimezoneOffset() * 60000;
    const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
    return localISOTime;
  };
  useEffect(() => {
    fetchData();
    fetchCostCenter();
    fetchSuppliers();
  }, []);
  const [formData, setFormData] = useState({
    PayOrderNo: '',
    Remarks: '',
    DocumentDate: getCurrentLocalDatetime(),
    SupplierContact: '',
    deliveryDate: getCurrentLocalDatetime(),
    deliveryPoint: '',
    location: '',
    contactPerson: '',
    requisitionNo: '',
    RequisitionType: DEFAULT_REQ_TYPE,
    lPOType: DEFAULT_LPO_TYPE,
    ContactNo: '',
    costCenter1: '',
    costCenter2: '',
    costCenter3: '',
    costCenter4: '',
    CostCentre5: '',
    currencyCode: '',
    QuotationReq: '',
    exchangeRate: '',
    Description: '',
    BuyerName: '',
    vendorId: '',
    vendorName: '',
    OrderType: [],
    paymentTerm: [],
    SupplierDep: [],
  });
  useEffect(() => {
    const item = location.state;
    const fetchPC = async () => {
      try {
        if (item.requisitionNo) {
          const apiService = new ApiService();
          let param = `?Id=${item.requisitionNo}`;
          const response = await apiService.getApiParamater('GET_PR', param);
          const SelectedReq = response?.data?.result[0];
          const supplierResponse = await apiService.get('GET_SUPPLIER_KANOO');
          setSupplier(supplierResponse?.data?.result);
          const selectedpaymentTerm = payments?.find((payment) => payment?.description === item?.paymentTerms);
          if (selectedpaymentTerm) {
            setPayment({ label: selectedpaymentTerm?.description, value: selectedpaymentTerm });
          }
          const selectedSuplier = supplierResponse?.data?.result?.find((sup) => sup?.supplierName === item?.vendorName);

          if (selectedSuplier) {
            setSupplierData({ label: selectedSuplier?.supplierName, value: selectedSuplier });
            setSupplierID({ label: selectedSuplier?.supplier_ID, value: selectedSuplier });
            setSupplierContact(selectedSuplier?.phoneNo1);
          }
          setIsVatExcluded(SelectedReq?.costCenter5);
          setContactNumber(SelectedReq?.contatNo);
          setFormData({
            requisitionNo: item?.requisitionNo,
            Remarks: item?.remarks,
            requestor: SelectedReq?.requestor,
            requisitionDate: SelectedReq?.requisitionDate || currentDatetimeUTC,
            deliveryDate: SelectedReq?.deliveryDate || currentDatetimeUTC,
            Department: SelectedReq?.department,
            deliveryPoint: SelectedReq?.deliveryPoint,
            contactPerson: SelectedReq?.contactPerson,
            location: SelectedReq?.location,
            QuotationReq: item?.pcNo,
            RequisitionType: SelectedReq?.type,
            costCenter1: { label: SelectedReq?.costCenter1, value: SelectedReq?.costCenter1 },
            costCenter2: { label: SelectedReq?.costCenter2, value: SelectedReq?.costCenter2 },
            costCenter3: { label: SelectedReq?.costCenter3, value: SelectedReq?.costCenter3 },
            costCenter4: { label: SelectedReq?.costCenter4, value: SelectedReq?.costCenter4 },
          });
        }
      } catch (error) {
        console.error('Error fetching  data:', error);
      }
    };
    if (item?.requisitionNo) {
      fetchPC();
    }
  }, [location.state]);

  useEffect(() => {
    checkCompanyName();
  }, [Company]);
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleMessage = (data) => {
    setMessageData(data);
    console.log(data, 'reqData');
  };
  const handleAuthorization = (data) => {
    setAuthorizationData(data);
    console.log(data, 'reqData');
  };
  const handlecurChange = (selectedOption) => {
    setFormData({ ...formData, currencyCode: selectedOption?.value?.code });
  };
  const handleVatChange = () => {
    setIsVatExcluded(!isVatExcluded);
  };
  const handleContactChange = (e) => {
    const { name, value } = e.target;
    if (name === 'ContactNo' && value.length > 16) {
      return;
    }
    if (name === 'ContactNo' && value < 0) {
      return;
    }
    setContactNumber(e.target.value);
  };
  const handleDiscountChange = () => {
    setIsDiscountPercentage(!isDiscountPercentage);
  };
  const orderType = [
    { value: 'None', label: 'None' },
    { value: 'Local Purchase', label: 'Local Purchase' },
    { value: 'Import Purchase', label: 'Import Purchase' },
    { value: 'Fixed Assist Purchase', label: 'Fixed Assist Purchase' },
    { value: 'Non Inventory Purchase', label: 'Non Inventory Purchase' },
    { value: 'Hire Purchase', label: 'Hire Purchase' },
    { value: 'Internal Pay Order', label: 'Internal Pay Order' },
    { value: 'Open Pay Order', label: 'Open Pay Order' },
  ];

  const itemType = [
    { value: 'None', label: 'None' },
    { value: 'Inventory', label: 'Inventory' },
    { value: 'Fixed Asset', label: 'Fixed Asset' },
    { value: 'Services', label: 'Services' },
    { value: 'Minor Asset', label: 'Minor Asset' },
    { value: 'PPM', label: 'PPM' },
  ];
  const LPOType = [
    // { value: 'None', label: 'None' },
    { value: 'Commercial', label: 'Commercial' },
    { value: 'Family', label: 'Family' },
  ];
  let param = `?isActive=true`;

  const fetchDocId = async (lPOType = formData.lPOType || DEFAULT_LPO_TYPE) => {
    const typeOfDoc = getTypeOfDocFromLpo(lPOType);
    const docParam = `?TypeOfDoc=${encodeURIComponent(typeOfDoc)}&DocId=POrder`;
    const docRes = await apiService.getApiParamater('GET_DOC_ID', docParam);
    setDocNumber(docRes?.data?.result?.[0]?.docId);
    return docRes;
  };

  const GenerateNumber = async () => {
    await fetchDocId();
    onCloseModal();
  };
  const fetchCostCenter = async () => {
    try {
      let cost1 = await apiService.get('GET_COST_ONE');
      setCost1([{ value: null, description: 'None' }, ...cost1?.data?.result]);
      let cost2 = await apiService.get('GET_COST_TWO');
      setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
      let cost3 = await apiService.get('GET_COST_THREE');
      setCost3([{ value: null, description: 'None' }, ...cost3?.data?.result]);
      let cost4 = await apiService.get('GET_COST_FOUR');
      setCost4([{ value: null, description: 'None' }, ...cost4?.data?.result]);
    } catch (error) {
      console.error('Error fetching Cost Center data:', error);
    }
  };
  const fetchSuppliers = async () => {
    try {
      const supplierResponse = await apiService.get('GET_SUPPLIER_KANOO');
      setSupplier(supplierResponse?.data?.result);
      const response = await apiService.get('GET_EPAYMENT');
      setPayments([{ value: null, description: 'None' }, ...response?.data?.result]);
      let res = await apiService.getApiParamater('GET_CURRENCY_MASTER', param);
      const filteredDenominations = res?.data?.result?.find((currency) => currency?.isDefault === true);
      if (filteredDenominations) {
        setSelectedCurency({ label: filteredDenominations.code, value: filteredDenominations });
      }
      setFormData((prev) => ({
        ...prev,
        exchangeRate: filteredDenominations?.conversionRate,
      }));
    } catch (error) {
      console.error('Error fetching Cost Center data:', error);
    }
  };
  const fetchData = async () => {
    try {
      await fetchDocId();
      const params = new URLSearchParams();
      params.append('DocNo', '');
      params.append('DocumentType', 'POrder');
      const editresponse = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
      setUser(editresponse.data.result);
    } catch (error) {
      console.error('Error fetching Currency data:', error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'SupplierContact' && value.length > 16) {
      return;
    }
    if (name === 'SupplierContact' && value < 0) {
      return;
    }
    if (name === 'deliveryDate' || name === 'DocumentDate') {
      const dateParts = e.target.value.split('-');
      if (dateParts[0].length > 4) {
        return;
      }
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handlePayChange = (selectedOption) => {
    setPayment(selectedOption);
  };
  const handleSupplierChange = (selectedOption) => {
    setSupplierData({ label: selectedOption?.value?.supplierName, value: selectedOption });
    setSupplierID({ label: selectedOption?.value?.supplier_ID, value: selectedOption });
    setSupplierContact(selectedOption?.value?.phoneNo1);
    setPayment({ label: selectedOption?.value?.paymentTerm, value: selectedOption });
    let discountPerc = parseFloat(selectedOption?.value?.exp1 || 0)
    setOverallDiscount(discountPerc)
  };
  const handleDepChange = (selectedOption) => {
    setFormData({ ...formData, SupplierDep: selectedOption });
  };
  const handlePyorderChange = (selectedOption) => {
    setFormData({ ...formData, OrderType: selectedOption });
  };
  const createDirectPurchaseKanoo = async () => {
    setLoader(true);
    if (!selectedRows.length) {
      toast.warning('Please select at least one pending requisition line');
      setLoader(false);
      return;
    }
    if (!Supplier?.label) {
      toast.warning('Please Select Supplier');
      setLoader(false);
      return;
    } else if (!Payment.label) {
      toast.warning("Please Select Payment Term");
      setLoader(false)
      return;
    }
    const prec = SelectedCurrency?.value?.precision ?? 3;

    for (const item of selectedRows) {
      if (!item.itemDescription) {
        toast.warning('Please Select Item');
        setLoader(false);
        return;
      }
      if (!item.balQty || parseFloat(item.balQty) <= 0) {
        toast.warning(`${item.itemDescription} quantity must be greater than 0`);
        setLoader(false);
        return;
      }
      if (!item.unitPrice || parseFloat(item.unitPrice) <= 0) {
        toast.warning(`${item.itemDescription} unit price must be greater than 0`);
        setLoader(false);
        return;
      }
    }
    try {
      const apiService = new ApiService();

      const poDetails = selectedPendingLines.map((item, index) => {
        const sourceLine = item[index] || {};
        const qty = (item.balQty);
        const lineAmount = (item.unitPrice * item?.balQty);
        const lineDelivery = sourceLine.deliveryDate ? new Date(sourceLine.deliveryDate).toISOString() : formData?.deliveryDate;
        const vatPerc = item.vatPerc;
        const itemDiscountAmount = overallDiscount > 0 ? (lineAmount * overallDiscount) / 100 : 0;
        const afterDiscountAmount = (lineAmount - itemDiscountAmount);
        const vat = (afterDiscountAmount / 100) * (vatPerc || 0);
        const vatunit = qty > 0 ? ((vat / qty)).toFixed(prec) : 0;
        const totalLineAmount = afterDiscountAmount + vat;
        debugger
        return {
          pOrderNo: docNumber,
          srno: index + 1,
          itemCode: item.itemCode || '',
          itemDescription: item.itemDescription || '',
          sItemCode: '',
          uom: item.uom || '',
          budgetCode: '',
          qty: item?.balQty,
          cancelledQty: 0,
          returnQty: 0,
          unitPrice: parseFloat(Number(item?.unitPrice)?.toFixed(3)),
          amount: parseFloat(Number(totalLineAmount).toFixed(3)),
          baseAmount: parseFloat(Number(totalLineAmount).toFixed(3)),
          status: 0,
          requisitionNo: item.requisitionNo || formData?.requisitionNo || '',
          rsrno: item.srno,
          deliveryDate: lineDelivery || currentDatetimeUTC,
          vatDesc: item.vatDesc || item.vatDec || '',
          vatPerc,
          vatUnitPrice: parseFloat(Number(vatunit)?.toFixed(3)),
          vatAmount: parseFloat(Number(vat)?.toFixed(3)),
          vatBaseAmount: parseFloat(Number(vat)?.toFixed(3)),
          specification: item.specification ?? '',
          discount: parseFloat(Number(itemDiscountAmount)?.toFixed(3)),
          discountPerc: parseFloat(overallDiscount.toFixed(4) || 0),
        };
      });
      const userData = {
        pOrderNo: docNumber,
        docId: formData?.RequisitionType?.label || "",
        requisitionNo: formData?.requisitionNo || "",
        vendorId: SupplierID?.label || "",
        vendorName: Supplier?.label || "",
        docDate: currentDatetimeUTC,
        deliveryDate: formData?.deliveryDate,
        location: formData?.location || "",
        currencyCode: SelectedCurrency?.label || "",
        exchangeRate: formData?.exchangeRate || 0,
        terms: Payment.label || "",
        department: "",
        attention: SupplierContact || "",
        fax: formData?.lPOType?.label || '0',
        quotationRef: formData?.QuotationReq || "",
        contractNo: "",
        deliveryPoint: formData?.deliveryPoint || "",
        contactPerson: formData?.contactPerson || "",
        aprrovalUser: "",
        description: formData?.Description || "",
        remarks: formData?.Remarks || "",
        user: userName || "",
        costCenter1: formData?.costCenter1?.label || "",
        costCenter2: formData?.costCenter2?.label || "",
        costCenter3: formData?.costCenter3?.label || "",
        costCenter4: formData?.costCenter4?.label || "",
        costCenter5: isVatExcluded === true ? 'excluded' : 'Included',
        poType: "string",
        contractedValue: 0,
        poDetails: poDetails,
        discountPerc: parseFloat(overallDiscount.toFixed(2)) || 0,
      };
      debugger
      const response = await apiService.post('CREATE_PENDING_REQUISITIONS_PO_KANOO', userData);
      if (isPendingRequisitionsPOSuccess(response)) {
        const savedPOrderNo = getCreatedPOrderNo(response, docNumber);
        const successMessage = response?.data?.message || response?.data?.result?.message || 'Created successfully';

        const userData2 = {
          docType: 'POrder',
          docId: savedPOrderNo,
          department: 'IT',
          company: Company?.selectedCompany?.companyNo,
          userCode: userId,
          userName: userName,
        };
        const docBody = {
          docId: 'POrder',
          typeOfDoc: getTypeOfDocFromLpo(formData.lPOType || DEFAULT_LPO_TYPE),
        };
        await apiService.put('UPDATE_DOC_ID', docBody);
        if (attachments) {
          handleUpload('PurchaseOrder', savedPOrderNo);
        }
        await apiService.post('CREATE_DOC_AUTHORIZATION', userData2);
        const paramsGet = new URLSearchParams();
        paramsGet.append('docType', 'POrder');
        paramsGet.append('docId', savedPOrderNo);
        paramsGet.append('srno', 1);
        const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
        if (response3?.data?.result.length > 0) {
          const toEmails = response3?.data?.result?.map((user) => user.userEmail);
          const emailbody = {
            toEmails: toEmails,
            subject: 'Direct Purchase Kanoo',
            body: '',
            docNo: savedPOrderNo,
            srNo: 1,
            docType: 'POrder',
          };
          await apiService.post('DOC_APPROVAL_EMAIL_POST', emailbody);
        }
        const token = localStorage.getItem('Token');
        const DB = localStorage.getItem('DataBase');
        if (!token) {
          setLoader(false);
          alert('Auth token is missing! Unable to proceed.');
          return;
        }
        const popupWidth = 1000;
        const popupHeight = 600;
        const popupLeft = (window.screen.width - popupWidth) / 2;
        const popupTop = (window.screen.height - popupHeight) / 2;
        const popup = window.open(
          '',
          'ReportPopup',
          `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`,
        );

        if (popup) {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = REPORT_URL;
          form.target = 'ReportPopup';

          const inputs = [
            { name: 'authToken', value: token },
            { name: '_db', value: DB },
            { name: 'reportName', value: 'POrder' },
            { name: 'voucherNo', value: savedPOrderNo },
          ];

          inputs.forEach(({ name, value }) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            form.appendChild(input);
          });

          document.body.appendChild(form);
          form.submit();
          document.body.removeChild(form);
        }
        toast.success(`${savedPOrderNo}: ${successMessage}`);
        navigate('/Inventory/DirectPurchaseKanoo/List');
      } else if (response?.data?.statusCode === 208) {
        onOpenModal();
      } else {
        toast.error(getApiErrorMessage(response));
      }
    } catch (error) {
      console.error('Error creating Direct Purchase Kanoo:', error);
      toast.error(getApiErrorMessage(error));
    } finally {
      setLoader(false);
    }
  };
  const handleCost1 = async (selectedOption) => {
    let param = `?CostCenter1=${selectedOption?.label}`;
    let cost2 = await apiService.getApiParamater('GET_COST_TWO', param);
    if (cost2?.data?.result) {
      setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
    } else {
      setCost2([]);
    }
    setFormData({ ...formData, costCenter1: selectedOption });
  };
  const handleCost2 = (selectedOption) => {
    setFormData({ ...formData, costCenter2: selectedOption });
  };
  const handleCost3 = (selectedOption) => {
    setFormData({ ...formData, costCenter3: selectedOption });
  };
  const handleCost4 = (selectedOption) => {
    setFormData({ ...formData, costCenter4: selectedOption });
  };
  const handleBackClick = () => {
    window.history.back();
  };
  const handleItemTypeChange = (selectedOption) => {
    setFormData({ ...formData, RequisitionType: selectedOption });
  };
  const handlePendingSelectionChange = (selectedLines) => {
    setSelectedPendingLines(selectedLines || []);
    if (!selectedLines?.length) return;

    const firstLine = selectedLines[0];
    const uniqueReqNos = [...new Set(selectedLines.map((l) => l?.requisitionNo).filter(Boolean))];
    const headerReqNo = uniqueReqNos.length === 1 ? uniqueReqNos[0] : uniqueReqNos.join(', ');

    let vendorName = firstLine?.vendorName || '';
    const supplierId = firstLine?.supplierId;
    if (!vendorName && supplierId && supplierId !== '0') vendorName = supplierId;
    if (!vendorName && firstLine?.supplier && firstLine.supplier !== '0') vendorName = firstLine.supplier;
    if (vendorName && suppliers?.length) {
      const selectedSuplier = suppliers.find((sup) => sup?.supplierName === vendorName || String(sup?.supplier_ID) === String(vendorName));
      if (selectedSuplier) {
        setSupplierData({ label: selectedSuplier.supplierName, value: selectedSuplier });
        setSupplierID({ label: selectedSuplier.supplier_ID, value: selectedSuplier });
        setSupplierContact(selectedSuplier.phoneNo1);
      }
    }

    setFormData((prev) => ({
      ...prev,
      requisitionNo: headerReqNo,
      deliveryDate: currentDatetimeUTC,
      deliveryNote: firstLine?.boq || "",
      // costCenter1: firstLine?.costCenter1 ? { label: firstLine.costCenter1, value: firstLine.costCenter1 } : prev.costCenter1,
      // costCenter2: firstLine?.costCenter2 ? { label: firstLine.costCenter2, value: firstLine.costCenter2 } : prev.costCenter2,
    }));
  };
  const handleTypeChange = async (selectedOption) => {
    setFormData({ ...formData, lPOType: selectedOption });
    try {
      await fetchDocId(selectedOption);
    } catch (error) {
      console.error('Error fetching document id for LPO type:', error);
    }
  };
  const preventNegativeSign = (e) => {
    if (e.key === '-') {
      e.preventDefault();
    }
  };
  // Attachment Functions
  const handleFileSelect = useCallback((file, id) => {
    setAttachments((prev) => {
      const updated = prev.map((row) => (row.id === id ? { ...row, file, fileName: file.name } : row));
      return [...updated, createEmptyRow()];
    });
  }, []);
  const handleRemarkChange = (id, value) => {
    setAttachments((prev) => prev.map((row) => (row.id === id ? { ...row, remarks: value } : row)));
  };
  const handleDelete = (id) => {
    setAttachments((prev) => prev.filter((row) => row.id !== id));
  };
  const handleView = (file) => {
    if (!file) return;

    if (isReadOnly) {
      setPreviewImage(file);
    } else {
      setPreviewImage(URL.createObjectURL(file));
    }
    setPreviewModal(true);
  };
  const handleUpload = async (name, docNo) => {
    const formData = new FormData();

    attachments.forEach(({ file }) => {
      if (file instanceof File) {
        formData.append('Images', file, file.name);
      }
    });

    const response = await apiService.postMultiPart('UPLOAD_FILE', formData);

    if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
      const uploadedFileNames = response.data.result.split(',');

      const payload = {
        docFilesDtos: attachments
          .filter((a) => a.file)
          .map((a, index) => ({
            srno: index + 1,
            docNo: docNo,
            docType: name,
            fileName: uploadedFileNames[index]?.trim(),
            remarks: a.remarks || '',
          })),
      };

      await apiService.post('CREATE_ATTACHMENT', payload);
      return;
    }
  };
  const checkCompanyName = () => {
    const DB = localStorage.getItem('DataBase');
    const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
    const defaultCompany = companies.find((comp) => comp.dataDB === DB);
    const companyName = defaultCompany?.companyName?.toLowerCase() || '';
    const isXtreamCashier = companyName.includes('accountcode') || companyName.includes('kanoo') || companyName.includes('bh');
    debugger
    setXtreamCompany(isXtreamCashier);
  };
  return (
    <div className="px-4">
      <div className="d-flex justify-content-between pt-3">
        <h5 className="col mainInvHead">Direct Purchase Kanoo</h5>
        <div className="d-flex gap-3">
          {loader === true ? (
            <button className="mainbtn " type="submit">
              <ClipLoader color="#ffffff" size={25} />
            </button>
          ) : (
            <button className="mainbtn " type="submit" onClick={createDirectPurchaseKanoo}>
              <FaSave className="center mt-1 mx-2" />
              <div>Save</div>
            </button>
          )}
          <button className="mainbtnRed">
            <RiRefreshLine className="center mt-1 mx-2" />
            <div>Reset</div>
          </button>
          <button onClick={handleBackClick} className="mainbtnSecondary">
            <FaAngleLeft className="center mt-1 mx-2" />
            <div>Back</div>
          </button>
        </div>
      </div>
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setPOTab(!POTab)}>
          <div className="h6 pt-1">Direct Purchase Kanoo Details</div>
        </div>
        <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
          <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
            <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '20px' }}>
              {isXtreamCompany === false ? "" :
                <div className="d-flex">
                  <label htmlFor="RequisitionType" className="form-label center">
                    LPO Type
                  </label>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9,
                    })}
                    value={formData.lPOType}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                        color: state.isFocused ? '#000 ' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000 ',
                        },
                      }),
                    }}
                    className="w-70 p-0"
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                    options={LPOType}
                    onChange={(selectedOption) => handleTypeChange(selectedOption)}
                  />
                </div>
              }
              <div className="d-flex">
                <label htmlFor="InvoiceNO" className="form-label center">
                  Direct Purchase Kanoo No
                </label>
                <input className="form-Input w-70" value={docNumber} name="docNumber" disabled />
              </div>
              <div className="d-flex">
                <label htmlFor="DeliveryDate" className="form-label center">
                  Delivery Date
                </label>
                <input
                  type="datetime-local"
                  className="form-Input w-70"
                  id="DeliveryDate"
                  value={formData.deliveryDate}
                  onChange={handleInputChange}
                  name="deliveryDate"
                />
              </div>
              <div className="d-flex">
                <label htmlFor="Currency" className="form-label center">
                  Currency{' '}
                </label>
                <Select
                  isSearchable={false}
                  value={SelectedCurrency}
                  className="w-70 p-0"
                  onChange={(e) => handlecurChange(e)}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="DocumentDate" className="form-label center">
                  Document Date
                </label>
                <input
                  className="form-Input w-70"
                  id="DocumentDate"
                  value={formData.DocumentDate}
                  type="datetime-local"
                  defaultValue={new Date().toISOString().substr(0, 10)}
                  name="DocumentDate"
                  onChange={handleInputChange}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="deliveryPoint" className="form-label center">
                  Delivery Point
                </label>
                <input
                  type="text"
                  className="form-Input w-70"
                  id="deliveryPoint"
                  value={formData?.deliveryPoint}
                  onChange={handleInputChange}
                  name="deliveryPoint"
                />
              </div>
              <div className="d-flex">
                <label htmlFor="ExchangeRate" className="form-label center">
                  Exchange Rate{' '}
                </label>
                <input type="text" className="form-Input w-70" disabled id="exchangeRate" value={formData.exchangeRate} name="exchangeRate" />
              </div>
              <div className="d-flex">
                <label htmlFor="requisitionNo" className="form-label center">
                  Requisition No
                </label>
                <input className="form-Input w-70" name="requisitionNo" id="requisitionNo" disabled value={formData.requisitionNo} />
              </div>
              <div className="d-flex">
                <label htmlFor="location" className="form-label center">
                  Location
                </label>
                <input type="text" className="form-Input w-70" id="location" value={formData.location} onChange={handleInputChange} name="location" />
              </div>
              <div className="d-flex">
                <label htmlFor="Description" className="form-label center">
                  Description
                </label>
                <input type="text" className="form-Input w-70" id="Description" value={formData.Description} onChange={handleInputChange} name="Description" />
              </div>
              <div className="d-flex">
                <label htmlFor="RequisitionType" className="form-label center">
                  Requisition Type
                </label>
                {itemData?.vendorName ? (
                  <input
                    type="text"
                    className="form-Input w-70"
                    id="RequisitionType"
                    disabled
                    value={formData.RequisitionType}
                    onChange={handleInputChange}
                    name="RequisitionType"
                  />
                ) : (
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9,
                    })}
                    value={formData.RequisitionType}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                        color: state.isFocused ? '#000 ' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000 ',
                        },
                      }),
                    }}
                    className="w-70 p-0"
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                    options={itemType}
                    onChange={(selectedOption) => handleItemTypeChange(selectedOption)}
                  />
                )}
              </div>
              <div className="d-flex">
                <label htmlFor="contactPerson" className="form-label center">
                  Contact Person
                </label>
                <input
                  type="text"
                  className="form-Input w-70"
                  id="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleInputChange}
                  name="contactPerson"
                />
              </div>
              <div className="d-flex">
                <label htmlFor="Remarks" className="form-label center">
                  Remarks
                </label>
                <input type="text" className="form-Input w-70" id="Remarks" value={formData.Remarks} onChange={handleInputChange} name="Remarks" />
              </div>
              <div className="d-flex">
                <label htmlFor="QuotationReq" className="form-label center">
                  Quotation Req
                </label>
                <input
                  type="text"
                  className="form-Input w-70"
                  id="QuotationReq"
                  disabled
                  value={formData.QuotationReq}
                  onChange={handleInputChange}
                  name="QuotationReq"
                />
              </div>
              <div className="d-flex">
                <label htmlFor="ContactNo" className="form-label center">
                  Contact No
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-Input w-70"
                  id="ContactNo"
                  value={contactNumber}
                  onKeyDown={preventNegativeSign}
                  onChange={handleContactChange}
                  name="ContactNo"
                />
              </div>
              <div className="d-flex">
                <label htmlFor="Description" className="form-label center">
                  Pay OrderType
                </label>
                <Select
                  options={orderType}
                  value={formData.OrderType}
                  className="w-70 p-0"
                  onChange={(selectedOption) => handlePyorderChange(selectedOption)}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 8,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="BuyerName" className="form-label center">
                  Buyer Name
                </label>
                <input type="text" className="form-Input w-70" id="BuyerName" value={formData.BuyerName} onChange={handleInputChange} name="BuyerName" />
              </div>
              <div className="d-flex">
                <label htmlFor="BuyerName" className="form-label center">
                  Delivery Note No
                </label>
                <input
                  type="text"
                  className="form-Input w-70"
                  id="deliveryNote"
                  value={formData.deliveryNote}
                  onChange={handleInputChange}
                  name="deliveryNote"
                />
              </div>
              <div className="p-2 brderbox center" onClick={() => handleOpen()} role="button" style={{ cursor: 'pointer' }}>
                Attachment
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setSupplierTab(!SupplierTab)}>
          <div className="h6 pt-1">Supplier Details</div>
        </div>
        <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '20px' }}>
              <div className="d-flex">
                <label htmlFor="inventoryAccountCode" className="form-label center">
                  Vendor ID
                </label>
                <Select
                  value={SupplierID}
                  isDisabled={itemData?.vendorName ? true : false}
                  options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplier_ID }))}
                  onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                  className="w-70 p-0"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="inventoryAccountCode" className="form-label center">
                  Vendor Name
                </label>
                <Select
                  value={Supplier}
                  className="w-70 p-0"
                  isDisabled={itemData?.vendorName ? true : false}
                  options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                  onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="inventoryAccountCode" className="form-label center">
                  Payment terms
                </label>
                <Select
                  className="w-70 p-0"
                  value={Payment}
                  isDisabled={itemData?.vendorName ? true : false}
                  onChange={(selectedOption) => handlePayChange(selectedOption)}
                  options={payments?.map((sup) => ({ value: sup, label: sup?.description }))}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="inventoryAccountCode" className="form-label center">
                  Vendor Dept
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-70 p-0"
                  isDisabled={itemData?.vendorName ? true : false}
                  value={formData.SupplierDep}
                  // options={department?.map((dep) => ({ value: dep, label: dep?.description }))}
                  onChange={(selectedOption) => handleDepChange(selectedOption)}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="Property" className="form-label center">
                  Vendor Contact
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-Input w-70"
                  id="SupplierContact"
                  disabled={itemData?.vendorName ? true : false}
                  value={SupplierContact}
                  onChange={handleInputChange}
                  name="SupplierContact"
                />
              </div>
              <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-between">
                  <div className="form-check">
                    <input
                      style={{ width: '26px', height: '26px' }}
                      type="checkbox"
                      className="form-check-input"
                      checked={isVatExcluded}
                      onChange={handleVatChange}
                    />
                    <label className="form-check-label mx-2 mt-1">Vat Excluded</label>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="form-check">
                    <input
                      style={{ width: '26px', height: '26px' }}
                      type="checkbox"
                      className="form-check-input"
                      disabled
                    // checked={isDiscountPercentage}
                    // onChange={handleDiscountChange}
                    />
                    <label className="form-check-label mx-2 mt-1">Discount in %</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setCostTab(!CostTab)}>
          <div className="h6 pt-1">Cost Center Details</div>
        </div>
        <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '20px' }}>
              <div className="d-flex">
                <label htmlFor="costCenter1" className="form-label center">
                  Property
                </label>
                <Select
                  id="costCenter1"
                  value={formData.costCenter1}
                  isDisabled={!!itemData?.vendorName}
                  onChange={handleCost1}
                  options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                  className="flex-grow-1"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 8,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPlacement="auto"
                  menuShouldScrollIntoView={false}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="costCenter2" className="form-label center">
                  Unit
                </label>
                <Select
                  id="costCenter2"
                  value={formData.costCenter2}
                  isDisabled={!!itemData?.vendorName}
                  onChange={handleCost2}
                  options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                  className="flex-grow-1"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPlacement="auto"
                  menuShouldScrollIntoView={false}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="costCenter3" className="form-label center">
                  {isXtreamCompany === false ? 'Cost Center 3' : 'Nature of Job'}
                </label>
                <Select
                  id="costCenter3"
                  value={formData.costCenter3}
                  isDisabled={!!itemData?.vendorName}
                  onChange={handleCost3}
                  options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                  className="flex-grow-1"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPlacement="auto"
                  menuShouldScrollIntoView={false}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">
                  {isXtreamCompany === false ? 'Cost Center 4' : 'Work Order No'}
                </label>
                <Select
                  id="costCenter4"
                  value={formData.costCenter4}
                  isDisabled={!!itemData?.vendorName}
                  onChange={handleCost4}
                  options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                  className="flex-grow-1"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPlacement="auto"
                  menuShouldScrollIntoView={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="slide-container p-2 mt-3">
        <div className="container-fluid">
          <div className="nav nav-pills overslid d-flex gap-4">
            <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
              Items
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
              Authorization
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
              Terms
            </div>
          </div>
        </div>
      </div>
      <div className="grid-1 brderbox2 p-4 mb-3">
        {gridVisibility[0] && (
          <PendingRequisitionsGrid
            requisitionType={formData.RequisitionType}
            onSelectionChange={handlePendingSelectionChange}
            selectedCheck={isVatExcluded}
            currencyPrecision={SelectedCurrency?.value?.precision} setSelectedRows={setSelectedRows} selectedRows={selectedRows}
            setOverallDiscount={setOverallDiscount} overallDiscount={overallDiscount} setDiscountAmount={setDiscountAmount}
            discountAmount={discountAmount} setGrandTotal={setGrandTotal} grandTotal={grandTotal}
            isDiscountPercentage={isDiscountPercentage} setVatAmount={setVatAmount} vatAmount={vatAmount}
          />
        )}
        {gridVisibility[1] && <Authorization handleAuthorization={handleAuthorization} usersDetails={usersDetails} setUser={setUser} itemData={itemData} />}
        {gridVisibility[2] && (
          <div className="grid-3 border">
            <MessageGrid handleMessage={handleMessage} />
          </div>
        )}
      </div>
      <div>
        <Attachment
          open={attachmentModal}
          onClose={closeModal}
          documentNo={docNumber}
          rows={attachments}
          readOnly={isReadOnly}
          onFileSelect={handleFileSelect}
          onRemarkChange={handleRemarkChange}
          onDelete={handleDelete}
          onView={handleView}
          onSave={handleUpload}
          previewImage={previewImage}
          previewOpen={previewModal}
          closePreview={() => setPreviewModal(false)}
        />
      </div>
      <Modal size="md" show={docModal} onHide={() => setDocModal(false)} backdrop="static" contentLabel="Doc Id Modal">
        <Modal.Header closeButton>
          <Modal.Title className="center">Direct Purchase Kanoo Number</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-danger">The Direct Purchase Kanoo number already exists. Click "Generate" to assign a new number.</p>
        </Modal.Body>
        <Modal.Footer className="end p-3">
          <button className="mainbtnGry" onClick={onCloseModal}>
            Cancel
          </button>
          <button className="mainbtnRed" onClick={GenerateNumber}>
            Generate
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateDirectPurchaseKanoo;
